import styled from "@emotion/styled";
const MessageFile = {
    Wrapper: styled.div `
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 1em;
    border-radius: 0.25rem;
    background-color: ${({ theme }) => theme.color.badge};
    min-width: 0;
  `,
    TextWrapper: styled.div `
    display: flex;
    flex-direction: column;
    min-width: 0;
  `,
    FileName: styled.p `
    margin: 0;
    font-size: 14px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
    FileExtension: styled.p `
    margin: 0;
    font-size: 14px;
    font-weight: normal;
    flex-shrink: 1;
  `,
    Anchor: styled.a `
    margin: 0;
    text-decoration: none;
    font-size: 16px;
    font-weight: bold;
    color: ${({ theme }) => theme.color.text};
    &:hover {
      text-decoration: underline;
    }
  `,
    PreviewWrapper: styled.div `
    margin-top: 1rem;
    & > img {
      max-width: 30%;
      display: block;
      border-radius: 4px;
      border: 1px solid rgb(29 28 29 / 13%);
    }
  }
  `,
};
export default MessageFile;
//# sourceMappingURL=MessageFile.styled.js.map